import {useState, useContext, useMemo} from 'react'
import {toAbsoluteUrl, KTIcon} from '../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import CreateNewPodCustomModal from '../create-new-pod-wizard/CreateNewPodModal'
import PodCreateKM from '../know_more_modals/pod_create_KM/PodCreateKM'
import {PageTitle} from '../../../_metronic/layout/core'
import AppContext from '../../AppContext'
import {useIntl, FormattedMessage} from 'react-intl'
import {useThemeMode} from '../../../_metronic/partials'
import {PrimaryOutlineButton} from '../../ui/PrimaryOutlineButton'
import NoDataImg from './undraw_document-search_2o7x.svg'
import './index.css'
import {useAuth} from '../auth'

function MyPodsMain() {
  const {mode} = useThemeMode()
  const {podsData, getPodsData, isLoading} = useContext(AppContext)
  const intl = useIntl()
  const {currentUser} = useAuth()
  // const podsData: any = []
  // const {execute, loading: isLoading} = usePostApi()
  // const [podsData, setPodsData] = useState([])
  // const getPodsData = async () => {
  //   try {
  //     const url = '/pod/list'
  //     const formData = {}

  //     const response = await execute(url, 'POST', formData)
  //     setPodsData(response.data)
  //     secureLocalStorage.setItem('jb_pods_list', response?.data)
  //   } catch (error) {
  //     console.error('Error:', error)
  //   }
  // }

  const [showModal, setShowModal] = useState(false)
  const handleOpenModal = () => {
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setShowModal(false)
  }
  const myPods = [
    {
      title: 'My Account',
      path: `/my-pods`,
      isSeparator: false,
      isActive: false,
    },
    {
      title: ``,
      path: `/my-pods`,
      isSeparator: true,
      isActive: false,
    },
    {
      title: `My PODs`,
      path: `/my-pods`,
      isSeparator: false,
      isActive: false,
    },
  ]

  const [inputVal, setInputVal] = useState('')

  const filteredData = useMemo(() => {
    return podsData
      ? podsData.filter((each: any) => {
          const pod_brand_name = each.pod_brand_name?.toLowerCase().includes(inputVal.toLowerCase())
          const pod_business_name = each.pod_business_name
            ?.toLowerCase()
            .includes(inputVal.toLowerCase())
          const url = each.url?.toLowerCase().includes(inputVal.toLowerCase())
          const pod_industry_name = each.pod_industry_name
            ?.toLowerCase()
            .includes(inputVal.toLowerCase())
          return pod_brand_name || url || pod_business_name || pod_industry_name
        })
      : []
  }, [inputVal, podsData])

  const cardImg = mode === 'dark' ? 'abstract-2-dark' : 'abstract-2'

  return (
    <>
      <PageTitle breadcrumbs={myPods}>My PODs</PageTitle>
      {isLoading ? (
        <div className='card h-250px'>
          <div className='m-auto d-flex flex-column align-items-center'>
            <div className='spinner-border spinner-primary mr-15'></div>
          </div>
        </div>
      ) : (
        <>
          {isLoading === false && (podsData || []).length === 0 ? (
            <>
              {/* <div className='h-100 no-data-view-con d-flex flex-column justify-content-center align-items-center'>
                <div className='d-flex flex-column justify-content-center align-items-center'>
                  <img src={NoDataImg} className='no-data-img' alt='no-data-img' />
                  <h3 className='mt-3'>Hi, {currentUser?.first_name || ''}!</h3>
                  <p className='mb-0 text-muted fw-semibold'>
                    There're no data for you to see yet.
                  </p>
                  <p className='mb-0 text-muted fw-semibold'>
                    If you want to create new POD just click
                  </p>
                  <button className='btn btn-light-primary btn-sm my-2' onClick={handleOpenModal}>
                    <KTIcon iconName='plus' className='fs-2' />
                    Create New POD
                  </button>
                  <p className='text-muted fw-semibold'>and go ahead.</p>
                </div>
              </div> */}

              <PodCreateKM />
              <div className='d-flex justify-content-center pt-5'>
                <div className='d-flex flex-column justify-content-center text-center'>
                  <h6 className='fw-normal'>
                    You don't have any PODs yet. Create a new POD using the button below.
                  </h6>
                  <div>
                    <button className='btn btn-light-primary btn-sm' onClick={handleOpenModal}>
                      <KTIcon iconName='plus' className='fs-2' />
                      Create New POD
                    </button>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className='d-flex flex-wrap justify-content-between align-items-center mb-5'>
                <h3 className='fw-semibold'>Available PODs in Your Account</h3>
                <div className='d-flex flex-wrap mt-3 mt-md-0'>
                  <div className='d-flex align-items-center position-relative me-4 mb-2 mb-md-0'>
                    <KTIcon iconName='magnifier' className='fs-3 position-absolute ms-3' />
                    <input
                      type='search'
                      id='kt_filter_search'
                      className='form-control form-control-white w-200px ps-9 fw-normal'
                      style={{paddingTop: '8px', paddingBottom: '8px'}}
                      placeholder='Search'
                      value={inputVal}
                      onChange={(e) => setInputVal(e.target.value)}
                    />
                  </div>
                  <div className='d-flex mt-md-0'>
                    <PrimaryOutlineButton
                      onClick={handleOpenModal}
                      iconName='plus'
                      className='d-flex align-items-center'
                    >
                      Create New POD
                    </PrimaryOutlineButton>

                    <PrimaryOutlineButton
                      onClick={getPodsData}
                      className='ms-4'
                      tooltip='Click to load the latest data.'
                    >
                      <i className='ki-solid ki-arrows-circle fs-2 text-primary'></i>
                    </PrimaryOutlineButton>
                  </div>
                </div>
              </div>

              <div className='row g-5 g-xl-5'>
                {/* {(podsData || []).map((each: any, index: number) => { */}
                {(filteredData || []).map((each: any, index: number) => {
                  let color = each.pod_pref_color ? each.pod_pref_color.substring(1) : ''
                  const brandName = encodeURIComponent(each.pod_brand_name)
                  return (
                    <div key={index} className='col-xl-3'>
                      <Link
                        to={`/${each.pod_code}/dashboard`}
                        className={`card bgi-no-repeat card-xl-stretch mb-xl-6`}
                        style={{
                          backgroundPosition: 'right top',
                          backgroundSize: '30% auto',
                          backgroundImage: `url(${toAbsoluteUrl(
                            `/media/svg/shapes/${cardImg}.svg`
                          )})`,
                        }}
                      >
                        <div className='card-body d-flex align-items-center px-5 py-5'>
                          <div className='d-flex flex-column justify-content-center'>
                            <img
                              src={
                                each.pod_logo?.url
                                  ? each.pod_logo?.url
                                  : `https://api-dev.jetboard.site/get/profile?name=${brandName}&color=${color}&size=128`
                              }
                              alt='pod logo'
                              className='h-auto w-90px me-3'
                              style={{borderRadius: '8px'}}
                            />
                          </div>
                          <div>
                            <p className='card-title fw-semibold fs-4 m-0 text-primary'>
                              {each.pod_brand_name}
                            </p>
                            <div className='fw-normal text-muted mb-2 mt-0'>
                              {each?.pod_business_name || ''}
                            </div>
                            <div className='d-flex flex-column flex-wrap fw-normal fs-6 pe-2 mb-2'>
                              <p className='d-flex align-items-center text-muted text-hover-primary mb-0 default-cursor'>
                                <span>
                                  <i className='ki-duotone ki-bank fs-4 me-1'>
                                    <span className='path1'></span>
                                    <span className='path2'></span>
                                  </i>
                                </span>
                                <span>{each?.pod_industry_name || ''}</span>
                              </p>
                              {each.url && (
                                <p className='d-flex align-items-center text-muted text-hover-primary mb-0 default-cursor fw-normal'>
                                  <i className='ki-duotone ki-disconnect fs-4 me-1'>
                                    <span className='path1'></span>
                                    <span className='path2'></span>
                                    <span className='path3'></span>
                                    <span className='path4'></span>
                                    <span className='path5'></span>
                                  </i>
                                  <span
                                    className='d-inline-block text-truncate'
                                    title={each?.url || ''}
                                    style={{maxWidth: '100%'}}
                                  >
                                    {each?.url || '-'}
                                  </span>
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* end::Body */}
                      </Link>
                    </div>
                  )
                })}
                {filteredData.length === 0 && (
                  <div className='card d-flex justify-content-center align-items-center h-250px'>
                    <h3 className='fw-semibold'>
                      {inputVal === '' ? (
                        intl.formatMessage({id: 'NO_RESULTS_FOUND_MSG'})
                      ) : (
                        <FormattedMessage
                          id='MSG.NO_DATA_MATCH'
                          values={{
                            inputVal: <span className='text-primary'>{inputVal}</span>,
                          }}
                        />
                      )}
                    </h3>
                  </div>
                )}
              </div>
            </>
          )}

          {/* <div className='d-flex justify-content-center pt-5'>
            <div className='d-flex flex-column justify-content-center'>
              <h6 className='fw-normal'>Select a POD from above or</h6>
              <button className='btn btn-light-primary btn-sm' onClick={handleOpenModal}>
                <KTIcon iconName='plus' className='fs-2' />
                Create New POD
              </button>
            </div>
          </div> */}
          <CreateNewPodCustomModal
            show={showModal}
            onClose={handleCloseModal}
            fetchPODsList={getPodsData}
          />
        </>
      )}
    </>
  )
}

export default MyPodsMain
